module.exports = __webpack_public_path__ + "img/icon3.c668ad4b.png";